<div class="slider">
  <div class="slider__container" (scroll)="checkElement()">
    <ng-container *ngFor="let card of offersData; let i=index; trackBy: trackByOfferId">
      <app-offer-card
        class="container__card"
        [cardData]="card" id="card_{{i}}"
        [offersType]="'offersOfApplicationInClosingProcess'"
        [eternalPage]="eternalPage"
        [resultPage]="resultPage"
        [closeDetail]="closeDetail"
        [inSlider]="true"
        [sliderWrapper]="true"
      ></app-offer-card>
    </ng-container>
  </div>
  <div class="slider__navigation">
    <div class="navigation__dots">
      <ng-container *ngFor="let card of offersData; let i=index; trackBy: trackByOfferId">
        <div class="dots__item"
             [ngClass]="{'active': activeDot == i}"
             id="dot_{{i}}"></div>
      </ng-container>
    </div>
    <div class="navigation__buttons">
      <div class="buttons__previous"
           [ngClass]="{'inactive': activeDot == 0}"
           (click)="clickPrevious()">vorherige</div>
      <div class="buttons__next"
           [ngClass]="{'inactive': activeDot >= (offersData.length - 1)}"
           (click)="clickNext()">nächste</div>
    </div>
  </div>
</div>
